'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { mediaURL } from '@/lib/sslByDomain';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface Sources {
  mediaItemUrl: string;
  mimeType: string;
}

interface VideoBackgroundProps {
  videoMP4: Sources;
  videoWebM?: Sources;
  videoMP4mobile?: Sources;
  videoWebMmobile?: Sources;
}

export default function VideoBackground({
  videoMP4,
  videoWebM,
  videoMP4mobile,
  videoWebMmobile,
}: VideoBackgroundProps) {
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  if (!videoMP4) return <></>;

  return (
    <video
      loop
      autoPlay
      muted
      playsInline
      className='video-background pointer-events-none absolute left-0 top-0 -z-10 max-h-full min-h-full w-screen object-cover'
    >
      {desktop ? (
        <>
          {videoWebM && (
            <source src={mediaURL(videoWebM?.mediaItemUrl)} type='video/webm' />
          )}
          <source src={mediaURL(videoMP4?.mediaItemUrl)} type='video/mp4' />
        </>
      ) : (
        <>
          {videoWebMmobile && (
            <source
              src={mediaURL(videoWebMmobile?.mediaItemUrl)}
              type='video/webm'
            />
          )}
          {videoMP4mobile ? (
            <source
              src={mediaURL(videoMP4mobile?.mediaItemUrl)}
              type='video/mp4'
            />
          ) : (
            <source src={mediaURL(videoMP4?.mediaItemUrl)} type='video/mp4' />
          )}
        </>
      )}
    </video>
  );
}
